<template>
  <b-container>
    <b-form-group :disabled="changes_disabled">
      <div>
        <!--         <b-alert
          v-for="warning in current_warnings"
          :key="JSON.stringify(warning)"
          show
          variant="info"
        >
          {{ $t(warning) }}
        </b-alert> -->
        <b-form-group>
          <label>
            <b> {{ $t('table_chosen') }} </b>
          </label>
          <b-form-select v-model="table" :options="table_options" />
        </b-form-group>
        <b-form-group>
          <label>
            <b> {{ $t('id_col_name') }} </b>
          </label>
          <manual-column-name v-model="id_generic_colname" />
        </b-form-group>
      </div>
    </b-form-group>
  </b-container>
</template>

<i18n>
{
  "en": {
    "id_col_name": "Name of the created id column",
    "cwrw_column_name_overridden": "The column name chosen already exists, it will overwrite the column"
  },
  "fr": {
    "id_col_name": "Nom donné à la nouvelle colonne d'identifiant",
    "cwrw_column_name_overridden": "Le nom de colonne choisi existe déjà, la colonne d'origine sera supprimée"
  }
}
</i18n>

<script>
import _ from 'lodash'

// import {
//   subscription_mixin,
//   brick_mixin,
//   metavariables_tracking_info_mixin,
//   brick_with_single_parent_mixin,
// } from '@/components/mixin.js'
import { global_brick_mixin } from '@/components/mixin.js'

import {
  BasicTableInfoEntity,
  GenericColumnName,
} from '@/components/object_model.js'
import ManualColumnName from '@/components/manual_column_name.vue'

// *****************************************************************************

export default {
  name: 'BrickAddIdColumn',
  components: {
    ManualColumnName,
  },
  // mixins: [
  //   subscription_mixin,
  //   brick_mixin,
  //   metavariables_tracking_info_mixin,
  //   brick_with_single_parent_mixin,
  // ],
  mixins: [global_brick_mixin],
  // props: [
  //   'brick_id',
  //   'project_id',
  //   'description_name',
  //   'metavariables_dicts_poids',
  // ],
  data() {
    return {
      table: -1,
      id_generic_colname: new GenericColumnName(),
    }
  },

  computed: {
    adapted_data() {
      let extended_table_info = []
      if (this.table !== -1) {
        let parent_info_entity_type = new BasicTableInfoEntity()
        parent_info_entity_type.uid = this.table
        extended_table_info = [parent_info_entity_type]
      }
      let adapted = {
        uid: this.brick_id,
        parents_info: extended_table_info,
        id_colname: this.id_generic_colname,
      }

      _.assignIn(adapted, this.description_name)

      return adapted
    },
  },
  watch: {
    cur_brick: {
      immediate: true,
      handler(new_val) {
        // N.B PL : Might not be necessary
        new_val = new_val || {}
        this.table = (new_val.parents_info[0] || {}).uid || -1
        this.id_generic_colname = new_val.id_colname
      },
    },
  },
}
</script>
